@if (isLoading()) {
  <div data-testid="loading-overlay" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80">
    <nsp-spinner class="h-16 w-16" />

    @if (showLongLoadingWarning()) {
      <div data-testid="loading-warning" class="absolute top-[calc(50%+70px)] left-1/2 -translate-x-1/2 text-center">
        <p class="mb-3">This is taking longer than expected. You may want to refresh the page.</p>

        <p-button label="Refresh Page" (onClick)="reloadPage()" />
      </div>
    }
  </div>
}
